import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Layout } from "antd";

import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";

import { getCompanies } from "../actions";

import ModalCompany from "../../components/ModalCompany";
import Loading from "../../components/Loading";
import { getCnpjUrl } from "../../helpers/functions";

import { onImportacao } from "../Company/Document/HistoricoImportacao/actions";

import hubConnection from "../../store/actions/signalr";

const { Content } = Layout;

function Main({ children }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const empresa = useSelector((state) => state.companies);
  const connection = useSelector((state) => state.signalr);

  const [visibleModal, setVisibleModal] = useState(false);

  const initialRender = useCallback(() => {
    if (localStorage.getItem("eRecuperadorAceito") === "false") {
      history.push("/contrato");
    } else if (!connection.hub) {
      dispatch(getCompanies());
      dispatch(hubConnection("importacao"));
    } else {
      dispatch(onImportacao(connection.hub));
    }
  }, [connection.hub]);

  useEffect(() => {
    initialRender();

    return () => {
      connection.hub && connection.hub.stop();
    };
  }, [initialRender]);

  useEffect(() => {
    const cnpj = getCnpjUrl();

    if (cnpj && !!empresa.list.length) {
      const tempEmpresa = empresa.list.find((item) => item.Cnpj === cnpj);

      if (!!tempEmpresa) {
        sessionStorage.setItem(
          "eRecuperadorCompany",
          JSON.stringify(tempEmpresa)
        );
      } else {
        history.push("/recuperacao");
      }
    }
  }, [empresa.list]);


  return (
    <>
      {!empresa.list && <Loading />}

      {visibleModal && (
        <ModalCompany
          visible={visibleModal}
          closeModal={() => setVisibleModal(false)}
        />
      )}

      <Layout className="layout">
        <Header />

        <Layout>
          <Sidebar openModal={() => setVisibleModal(true)} />

          <Layout>
            <Content>{children}</Content>
            <Footer />
          </Layout>
        </Layout>
      </Layout>
    </>
  );
}

export default Main;
